import "../App.css";
import "@material-ui/icons";
import Video from "./Video";
import "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import TopBar from "./TopBar";
import useScrollDirection from "../hooks/UseScrollDirection";
import Swal from 'sweetalert2';

function App() {
  const { scrollDir, scrollCallback } = useScrollDirection();
  const [videos, setVideos] = useState([]);
  const [pageFraction, setPageFraction] = useState(0);
  const scrollContainerRef = React.useRef(null);
  const rafRef = React.useRef(null);
  const prevActiveIndicesRef = React.useRef(new Set());
  const activeIndicesUpdateTimerRef = React.useRef(null);
  const [activeVideoIndices, setActiveVideoIndices] = useState(new Set([0]));

  useEffect(() => {
    getFavVideos();
  }, []);

  // Passive scroll event listener with requestAnimationFrame optimization
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleScroll = () => {
      // Cancel any pending animation frame
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }

      // Use requestAnimationFrame for smooth performance
      rafRef.current = requestAnimationFrame(() => {
        if (!scrollContainer) return;
        const scrollTop = scrollContainer.scrollTop;
        const clientHeight = scrollContainer.clientHeight;
        
        scrollCallback(scrollTop);
        const f = scrollTop / clientHeight;
        const newPage = Math.round(f);
        setPageFraction(newPage);
        
        // Track active videos (current + 5 before/after for smoother scrolling)
        // Extended buffer prevents pauses when scrolling - ReactPlayer stays mounted in buffer
        // Only unmounts when far outside buffer range
        const activeSet = new Set();
        const startIdx = Math.max(0, newPage - 5);
        const endIdx = Math.min(videos.length - 1, newPage + 5);
        for (let i = startIdx; i <= endIdx; i++) {
          activeSet.add(i);
        }
        
        // Efficient comparison: check if sets are different (much faster than Array.from().sort().join())
        const prevSet = prevActiveIndicesRef.current;
        let setsDiffer = prevSet.size !== activeSet.size;
        if (!setsDiffer) {
          // Only check contents if sizes match
          for (const idx of activeSet) {
            if (!prevSet.has(idx)) {
              setsDiffer = true;
              break;
            }
          }
        }
        
        // Update state immediately - Set comparison already prevents unnecessary updates
        // Removed debounce to eliminate pause when starting to scroll after pausing
        if (setsDiffer) {
          prevActiveIndicesRef.current = activeSet;
          // Clear any pending update (in case cleanup didn't run)
          if (activeIndicesUpdateTimerRef.current) {
            clearTimeout(activeIndicesUpdateTimerRef.current);
            activeIndicesUpdateTimerRef.current = null;
          }
          setActiveVideoIndices(activeSet);
        }
      });
    };

    // Add passive scroll listener
    scrollContainer.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      if (activeIndicesUpdateTimerRef.current) {
        clearTimeout(activeIndicesUpdateTimerRef.current);
      }
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [scrollCallback, videos.length]);

  // Initialize active video indices when videos load or page changes
  useEffect(() => {
    if (videos.length === 0) return;
    const activeSet = new Set();
    const currentPage = pageFraction >= 0 ? pageFraction : 0;
    // Extended buffer of 5 on each side for smoother scrolling
    for (let i = Math.max(0, currentPage - 5); i <= Math.min(videos.length - 1, currentPage + 5); i++) {
      activeSet.add(i);
    }
    prevActiveIndicesRef.current = activeSet;
    setActiveVideoIndices(activeSet);
  }, [videos.length, pageFraction]);
  /*
  const handleClearFavorites = () => {
    localStorage.removeItem("fav");
    setVideos([]);
    window.location.reload(false);
  };
  */
  const handleClearFavorites = () => {
    const message = "Are you sure you want to clear your favorites?";
  
    Swal.fire({
      title: 'Confirmation',
      text: message,
      icon: 'warning',
      showCancelButton: true,
    })
      .then((result) => {
        console.log("result = "+result.value);
        if (result.value === true) {
          console.log("Deleting favorites")
          localStorage.removeItem('fav');
          setVideos([]);
          window.location.reload(false);
        }
      });
  };

  const getFavVideos = async () => {
    console.log("getFavVideos");
    const videos = localStorage.getItem("fav");
    if (videos !== null) {
      const parsedVideos = JSON.parse(videos);
      setVideos(parsedVideos);
    }
  };

  return (
    <div className="app">
      <TopBar position="static"/>
      <div
        ref={scrollContainerRef}
        className="app_videos"
      >
        {videos?.length &&
          videos?.map((v, i) => {
            const isActive = activeVideoIndices.has(i);
            return (
              <Video
                key={v.url}
                index={i}
                item={v}
                page={pageFraction}
                scrollDir={scrollDir}
                isActive={isActive}
                {...v}
              />
            );
          })}
      </div>
<div className="debug" style={{ zIndex: 1000 }}>
  <div>
  {videos?.length > 0 ? (
    <span>
      Favourites: {pageFraction + 1} / {videos?.length}
    </span>
  ) : (
    <span>Favourites: No favourites</span>
  )}
  </div>
  <div className="favbutton">
    <div className="button-group">
      <button onClick={handleClearFavorites}>Clear</button>
    </div>
  </div>
</div>


    </div>
  );
}

export default App;